module.exports = __webpack_public_path__ + "static/media/no_picture.d479047a.svg";